// extracted by mini-css-extract-plugin
export default {"containerWelcome":"styles_containerWelcome__zuXa-","container":"styles_container__5bcF1","welcome":"styles_welcome__HI87w"};